import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockTake, StockTakeCreate, StockTakeFilter } from '../data/stockTake';

export function createStockTakeService(client: AxiosInstance) {
  return createCrudService<StockTake, StockTakeCreate, StockTakeFilter>(
    client,
    '/purchase/StockTake',
    'id',
  );
}

export type StockTakeService = CrudService<StockTake, StockTakeCreate, StockTakeFilter>;
